import Axios from "axios";

const state = {
    query: '',
    results: [],
}

const mutations = {
    SET_QUERY(state, payload) {

    },
    SET_RESULTS(state, payload) {

    }
}

const getters = {
    getQuery: state => state.query,
    getResults: state => state.results,
}

const actions = {
    searchFor({ getters }, query) {
        console.log('SEARCH: ', query)
        if (!query) return false
        return axios.get('wpvue/v2/search', {
            params: {
                q: query
            }
        }).then(res => {
            console.log('res: ', res)
            return true
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};